module.exports = __webpack_public_path__ + "img/bankomat.676680fb.png";